<template>
  <div class="page-course-try">
    <bottom-bar-layout v-if="tryItem"
                       :show-bar="showBar"
                       :bar-height="150"
                       barBackground="#fff"
    >
      <ym-video v-if="tryItem.mediaSrc !== ''"
                class="page-course-try-video"
                :src="tryItem.mediaSrc"
                :poster="tryItem.cover"
      />
      <div class="page-course-try-title">
        {{ tryItem.title }}
      </div>
      <div class="page-course-try-header">
        <div class="page-course-try-header-left">
          <ym-img class="icon"
                  :src="require('@/assets/img/course/title_try.png')"
          />
          <span>试听特辑</span>
        </div>
      </div>
      <div class="page-course-try-list">
        <div v-for="(item,index) in tryList"
             :key="index"
             class="page-course-try-list-item"
             :class="{ 'active': tryIndex === index }"
             @click="tryIndex = index"
             v-ym-report:COURSE_DETAIL_AUDITION_CLICK="{
               location: 'courseAuditionDetail',
               auditionId: item.id,
             }"
        >
          <ym-img v-if="tryIndex === index"
                  class="page-course-try-list-item-tag"
                  :src="require('@/assets/img/course/tag_left_top.png')"
          />
          <div class="page-course-try-list-item-top ym-line-ellipsis">{{ item.title }}</div>
          <div class="page-course-try-list-item-bottom">
            <ym-img class="icon"
                    :src="require('@/assets/img/course/lesson_duration.png')"
            />
            <span>{{ item.durationDesc }}</span>
          </div>
        </div>
      </div>
      <template #tabbar>
        <div class="footer-container">
          <div class="footer-container-left">
            <div class="footer-container-left-top ym-line-ellipsis">{{ course.title }}</div>
            <div class="footer-container-left-bottom">
              <div class="footer-container-left-bottom-tag">
                周{{ course.startTime|formatTime('a') }}
              </div>
              <div class="footer-container-left-bottom-date">
                {{ course.startTime|formatTime('MM月dd日') }} 开课
              </div>
            </div>
          </div>
          <div class="footer-container-right"
               @click="goBuy"
               v-ym-report:COURSE_DETAIL_ATONCE_BUYCOURSE_CLICK="
                 { location: 'auditionDetail' }"
          >
            立即购买
          </div>
        </div>
      </template>
    </bottom-bar-layout>
  </div>
</template>

<script>
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import YmVideo from '@/components/YmVideo';
  import { getCourseTryDetail } from '@/services/course';
  import { locationHref } from '@/utils';

  export default {
    name: 'PageClassRoom',
    metaInfo() {
      return {
        title: this.pageTitle,
      };
    },
    components: {
      YmVideo,
      BottomBarLayout,
    },
    computed: {
      showBar() {
        return this.course && !this.course.isBuy;
      },
      tryItem() {
        return this.tryList[this.tryIndex];
      },
    },
    data() {
      return {
        pageTitle: '试听特辑',
        course: null,
        tryList: [],
        tryIndex: 0,
      };
    },
    methods: {
      async fetchData(id) {
        const data = await getCourseTryDetail(id);
        this.tryList = data.audition;
        this.tryIndex = data.audition.findIndex(item => item.id === id);
        this.course = {
          title: data.title,
          startTime: data.startTime,
          isBuy: data.isBuy,
          buyUrl: data.buyUrl,
        };
      },
      goBuy() {
        locationHref(this.course.buyUrl);
      },
    },
    created() {
      const { id } = this.$route.params;
      this.fetchData(Number(id));
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-course-try {
    background-color: #fff;
    min-height: 100%;
    &-video {
      display: block;
      width: 100%;
      height: 420px;
    }
    &-title {
      padding: 30px 32px 60px;
      border-bottom: 11px solid #f4f4f4;
      color: #222;
      font-size: 32px;
      font-weight: bold;
    }
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 32px;
      padding-right: 40px;
      height: 122px;
      &-left {
        display: flex;
        align-items: center;
        .icon {
          width: 33px;
          height: 22px;
          margin-right: 6px;
        }
        span {
          color: #222;
          font-size: 32px;
          font-weight: bold;
        }
      }
    }
    &-list {
      display: flex;
      flex-wrap: nowrap;
      box-sizing: border-box;
      overflow-x: scroll;
      overflow-y: hidden;
      width: 100%;
      padding-left: 32px;
      padding-right: 2px;
      padding-bottom: 32px;
      &-item {
        position: relative;
        flex-shrink: 0;
        width: 410px;
        height: 128px;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 25px 20px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-color: @color-white;
        margin-right: 30px;
        &-top {
          color: @color-text-light;
          font-size: 28px;
          font-weight: @font-weight-bold;
        }
        &-bottom {
          display: flex;
          align-items: center;
          .icon {
            width: 24px;
            height: 24px;
            margin-right: 8px;
          }
          span {
            color: #999;
            font-size: 24px;
          }
        }
        &-tag {
          position: absolute;
          top: 0;
          left: 0;
          width: 30px;
          height: 30px;
        }
        &.active {
          .page-course-try-list-item-top {
            color: @color-black-dark;
          }
        }
      }
    }
  }

  .footer-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 32px;
    &-left {
      width: 437px;
      display: flex;
      flex-direction: column;
      &-top {
        color: #222;
        font-size: 28px;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 13px;
      }
      &-bottom {
        display: flex;
        align-items: center;
        &-tag {
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          border: 1px solid #222;
          padding: 0 11px;
          color: #222;
          font-size: 24px;
          margin-right: 16px;
        }
        &-date {
          color: #222;
          font-size: 28px;
        }
      }
    }
    &-right {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 208px;
      height: 100px;
      border-radius: 25px;
      background: linear-gradient(90deg, #48E4D8 0%, #02CCCC 100%);
      color: #fff;
      font-size: 32px;
      font-weight: bold;
    }
  }
</style>
